export default () => ({
  isShowing: false,
  isMobiled: false,
  next: false,
  notFound: false,
  notCode: false,
  token: null,
  check: {
    tenant_id: '29G85GQ'
  },
  optionsGenre: [
    {
      id: 'male',
      name: 'Masculino'
    },
    {
      id: 'female',
      name: 'Feminino'
    }
  ],
  tenant: {
    name: null,
    birthdate: null,
    genre: null,
    country_register: null,
    phone: null,
    password: null,
    password_confirmation: null,
    sms: true,
    terms: false,
    internal_regulation: false,
    token: null
  },
  errors: {
  },
  errorTrue: false
})



// WEBPACK FOOTER //
// ./src/app/auth/active/tenant/resources/data.js